import React, {useState} from 'react'
import { BaseLink, useRoute } from 'react-router5'
import {useTranslation} from "react-i18next";
import './style/nav.css'
import useSubscribeRouter from "../utils/useSubscribeRouter";

function Nav({ onLogout }) {
    const { router } = useRoute()
    const { route } = useSubscribeRouter(router);
    const route_name = route.name;
    const [opened, setOpen]= useState(false);

    const { t } = useTranslation();

    return (
      <nav className={"sidebar_nav " + (opened ? 'active' : '')}
           onMouseEnter={() => setOpen(true)}
           onMouseLeave={() => setOpen(false)}
           onClick={() => setOpen(false)} >
        <div className={'sidebar_menu'}>
            <div>
                <div className={'picto-reticular-logo'} />
                <div className={'picto-reticular-logo picto-app-config-logo'} />
            </div>
            <div className={'picto-spacer'} />

            <ul>
                <BaseLink router={router} routeName="postfeed">
                    <li>
                        <div className={'picto-home'}></div>
                        <span>{t('Home')}</span>
                    </li>
                </BaseLink>
                <BaseLink router={router} routeName="profile.focus">
                    <li>
                        <div className={'picto-focus'}></div>
                        <span>{t('Mes focus')}</span>
                    </li>
                </BaseLink>
                <BaseLink router={router} routeName="profile.bookmark" >
                    <li>
                        <div className={'picto-bookmark'}></div>
                        <span>{t('Mes signets')}</span>
                    </li>
                </BaseLink>
                <BaseLink router={router} routeName="trending">
                    <li>
                        <div className={'picto-trending'}></div>
                        <span>{t('Tendances')}</span>
                    </li>
                </BaseLink>
                <BaseLink router={router} routeName="IM">
                    <li>
                        <div className={route_name==='IM'?'IM active' : 'IM'}></div>
                        <span>{t('Messages')}</span>
                    </li>
                </BaseLink>
                <BaseLink router={router} routeName="carto">
                    <li>
                        <div className={'picto-carto'}></div>
                        <span>{t('Cartographie')}</span>
                    </li>
                </BaseLink>
                <BaseLink router={router} routeName="editor" className="editor_link">
                    <li>
                        <div className={'picto-editor'}></div>
                        <span>{t('Rédiger')}</span>
                    </li>
                </BaseLink>

                <div className={'picto-spacer'} />

                <BaseLink router={router} routeName="explore" routeOptions={{reload: true}}>
                    <li>
                        <div className={'picto-recherche'}></div>
                        <span>{t('Recherche')}</span>
                    </li>
                </BaseLink>
                <BaseLink router={router} routeName="settings">
                    <li>
                        <div className={'picto-settings'}></div>
                        <span>{t('Paramètres')}</span>
                    </li>
                </BaseLink>
                <div onClick={onLogout}>
                    <li>
                        <div className={'picto-logout'}></div>
                        <span>{t('Logout')}</span>
                    </li>
                </div>
            </ul>
        </div>
      </nav>
    )
}

export default Nav
